export const BUTTONS = {
	sendCode: "suspicious-login.send-code",
	continue: "general.continue",
};

export const COMMUNICATION_CHANNELS = ["SMS", "Email"];
